angular.module("app").controller("ProvidersListPageController", [
    '$scope',
    'preloadedData',
    'pageStatuses',
    'pagination',
    '$timeout',
    'casinoProviderService',
    'errorHandler',
    '$state',
    '$stateParams',
    function ($scope, preloadedData, pageStatuses, pagination, $timeout, casinoProviderService, errorHandler, $state, $stateParams) {
        var pendingListRequest;
        $scope.pageStatuses = pageStatuses;
        $scope.providers = angular.copy(preloadedData.providers);
        $scope.parentId = $stateParams.itemId;
        $scope.filterOptions = {
            status: pageStatuses[0]
        };

        $scope.pagination = pagination.init(function (resetPage) {
            !!pendingListRequest && $timeout.cancel(pendingListRequest);
            pendingListRequest = $timeout(function () {
                var requestData =  getFiltersValues();
                resetPage && (requestData.current_page = 1);
                $scope.parentId && (requestData.parent_id = $scope.parentId);
                updateList(requestData)
            }, 300);
        }, preloadedData.total_count);


        $scope.getItemChildes = function (category) {
            $state.go("main.categories.categoryItems", {itemId: category.id}, {reload: false})
        };


        $scope.editProvider = function (provider) {
            $state.go($scope.parentId ? "main.providers.editItem" : "main.providers.edit", {providerId: provider.name, itemId: $scope.parentId})
        };

        $scope.getDateTime = function (dateString) {
            return new Date(dateString).getTime()
        };

        function getFiltersValues() {
            return {
                current_page: $scope.pagination.page,
                limit: $scope.pagination.limit,
                status: $scope.filterOptions.status
            }
        }

        function updateList (requestOptions) {
            casinoProviderService.get(requestOptions).then(
                function (response) {
                    if (response.status === "ok") {
                        $scope.providers = angular.copy(response.providers)
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

    }
]);